import { deviceType, mobileModel, mobileVendor, osName, osVersion } from 'react-device-detect';

import { RECAPTCHA_TOKEN, APPLE, GOOGLE, PAYMENT_INITITATED_FALG, TEAM_PAGE } from "../../constants";
import { compiledName, getGiftAidAmount, totalCheckoutDonation } from "../../helpers";
import { RESET_COUNTRY_DEPENDENT_VALUES, RESET_PAYMENT_METHOD, SET_GOOGLE_APPLE_ID, UPDATE_CHECKOUT_CONTACT_DETAILS, UPDATE_CHECKOUT_STATE, UPDATE_CURRENCY, UPDATE_DONATION_MESSAGE, UPDATE_DONATION_PROCESSING_STATE, UPDATE_STATE_BASED_ON_LOCATION, UPDATE_STATE_BASED_ON_PAGE_DETAILS } from "../actionTypes/CheckoutTypes";
import { UserService } from '../../services/storage.service';
import { handlePayment } from '../services/CheckoutServices';
import { collectSourceURL } from '../../services/source.tracking.service';

function updateCheckoutState(event) {
    return {
        type: UPDATE_CHECKOUT_STATE,
        event,
    }

}

function updateCheckoutCurrency(currency) {
    return {
        type: UPDATE_CURRENCY,
        currency,
    }
}

function resetCountryDependentState() {
    return {
        type: RESET_COUNTRY_DEPENDENT_VALUES,
    }
}

function resetCheckoutPaymentMethod() {
    return { type: RESET_PAYMENT_METHOD }
}

function updateStateBasedOnLocation() {

    return (dispatch, getState) => {
        const location = getState().fundraiser_page.location_details
        try {
            dispatch({
                type: UPDATE_STATE_BASED_ON_LOCATION,
                location
            })
        }
        catch (e) {
            console.error("Error occurred while updating state based on location", e)
        }
    };
}

function updateStateBasedOnPageDetails(pageDetails) {
    return {
        type: UPDATE_STATE_BASED_ON_PAGE_DETAILS,
        pageDetails
    }
}

function updateDonationMessage(message) {
    return {
        type: UPDATE_DONATION_MESSAGE,
        message
    }
}
function updateCheckoutContactDetails(contactDetails) {
    return {
        type: UPDATE_CHECKOUT_CONTACT_DETAILS,
        contactDetails
    }
}

function setPaymentRef(type, ref) {
    return {
        type,
        ref
    }
}

function setGoogleApplePayId(id) {
    return {
        type: SET_GOOGLE_APPLE_ID,
        id
    }
}

function initiateDonationProcess(startTime) {
    return async (dispatch, getState) => {
        dispatch({
            type: UPDATE_DONATION_PROCESSING_STATE,
            processing: true
        });
        try {
            const recaptchaToken = await window.grecaptcha.execute(`${RECAPTCHA_TOKEN}`, { action: 'submit' });

            const storeState = getState();

            const isFundraiserCheckout = storeState.donationCheckout.isFundraiserCheckout;
            const pageDetails = isFundraiserCheckout ? storeState.fundraiser_page.fundraiser_details : storeState.fundraiser_page.campaign_details

            const state = storeState.donationCheckout;
            const donationImpact = storeState.donation.product_impact;

            const transactionFeeAmount = state.coverTheTransactionFee ? state.transactionFeePercentage : 0;
            const totalDonation = totalCheckoutDonation(state);
            const paymentMethodName = state.selectedPaymentMethod == GOOGLE || state.selectedPaymentMethod == APPLE ? 'google_apple' : state.selectedPaymentMethod
            const isTeamPage = pageDetails.page_type == TEAM_PAGE;
            const giftAidAmount = state.makeGiftAidDonation ?
                getGiftAidAmount(totalDonation) + parseInt(totalDonation)
                : 0;
            const googleApplePaymentId = storeState?.googleApplePaymentId;
             
            let payload = {
                document_referrer: collectSourceURL(),
                channel: 'p2p',
                g_recaptcha_response: recaptchaToken,
                user_id: UserService.userExist() ? UserService.getUser().id : 0,
                currency_id: state.selectedCountry.currency.id,
                country_id: state.selectedCountry.id,
                payment_method_name: paymentMethodName,
                transaction_fee_amount: (transactionFeeAmount / 100) * state.donationAmount,
                donation_amount: totalDonation,
                currency: state.selectedCountry?.currency?.code,
                product_id: donationImpact?.product_id | 0,
                product_impact: donationImpact?.product_impact | 0,
                product_quantity: donationImpact?.product_quantity | 0,
                product_name: donationImpact?.product_name | 0,
                is_anonymous: state.donateAnonymously,
                team_member_id: state.isFundraiserCheckout && isTeamPage ? state.selectedTeamMember.id : null,
                bill_to_forename: compiledName(state.userContactDetails.firstName),
                bill_to_surname: compiledName(state.userContactDetails.lastName),
                bill_to_email: state.userContactDetails.email,
                bill_to_address_line1: state.userContactDetails.address,
                bill_to_address_state: state.userContactDetails?.countryState,
                city: state.userContactDetails.city,
                zip_code: state.userContactDetails.zipCode,
                bill_to_phone: state.userContactDetails.contactNumber,
                country_state: state.userContactDetails?.countryState,
                is_guest_user: UserService.userExist() ? 0 : 1,
                donor_profile_country_id: state.userContactDetails?.country,
                is_zakat: state.donationType,
                is_recurring: state.isRecurring,
                is_same_billing_add: state.sameBillingForGiftAid ? "yes" : "no",
                organization_name: state.organizationName,
                fundraiser_name: pageDetails.page_title,
                total_time_taken: (new Date() - startTime) / 1000,
                //giftaid
                is_reclaim_giftaid: state.makeGiftAidDonation ? 1 : 0,
                giftaid_amount: giftAidAmount,
                //keep in touch values
                contact_me_by_email: state.contactByEmail,
                contact_me_by_phone: state.contactByPhone,
                contact_me_by_sms: state.contactBySms,
                dont_contact_me_by_post: state.doNotContactByPost,
                //goodLuckMessage
                good_luck_message: state.leaveAMessageWithDonation ? state.goodLuckMessage : "",
                //device info
                device_type: deviceType,
                os_version: osVersion,
                os_name: osName,
                mobile_vendor: mobileVendor,
                mobile_model: mobileModel,
            }

            if (!state.sameBillingForGiftAid)
                payload = {
                    ...payload,
                    bill_to_address_line1_giftaid: state.giftAidBilling.address,
                    bill_to_address_city_giftaid: state.giftAidBilling.city,
                    bill_to_address_country_giftaid: state.giftAidBilling.country,
                    bill_to_address_postal_code_giftaid: state.giftAidBilling.zipCode,
                    bill_to_address_state_giftaid: state.giftAidBilling.countryState,
                }

            if (state.doubleTheImpact) {
                payload = {
                    ...payload,
                    employer_name: state.corporateMatchEmployer,
                    contact_me_for_corporate_matching: state.contactMeForCorporateMatch,
                    is_corporate_match: 1
                }
            }

            if (
                typeof googleApplePaymentId === 'string' && googleApplePaymentId.trim() !== '' && 
                paymentMethodName === 'google_apple'
                ) {
                payload = {
                    ...payload,
                    payment_method: googleApplePaymentId,
                };
            }

            if (isFundraiserCheckout)
                payload = {
                    ...payload,
                    fundraiser_page_id: pageDetails.id
                }

            else payload = {
                ...payload,
                campaign_id: pageDetails.id
            }

            localStorage.setItem(PAYMENT_INITITATED_FALG, true);

            await handlePayment(payload);

        } catch (e) {
            console.error("Error occurred while processing donation", e)
        }
        finally {
            dispatch({
                type: UPDATE_DONATION_PROCESSING_STATE,
                processing: false
            });
        }
    };
}

export const checkoutActions = {
    setPaymentRef,
    updateCheckoutState,
    setGoogleApplePayId,
    updateDonationMessage,
    updateCheckoutCurrency,
    initiateDonationProcess,
    resetCountryDependentState,
    resetCheckoutPaymentMethod,
    updateStateBasedOnLocation,
    updateCheckoutContactDetails,
    updateStateBasedOnPageDetails,
}